module.exports = __webpack_public_path__ + "static/media/Kimberly P.fe1a4064.png";